module.exports = __webpack_public_path__ + "static/media/linkIcon.78ee6989.svg";